module.exports = __webpack_public_path__ + "img/4-1-2-1-preview-hk-60s.2458e8fc.jpg";